export default __webpack_public_path__ + "static/media/sprite.97710fd2.svg";